module.exports = __webpack_public_path__ + "img/starfish.8e2c6f99.png";